(function () {
    'use strict';

    angular.module('app')
        .factory('CountryService', CountryService)

    CountryService.$inject = ['$http', '$rootScope', '$q', '$location', '$timeout'];

    function CountryService($http, $rootScope, $q, $location, $timeout) {

        var availableLocalesURLs = ["", 'en-us'];
        var currentLocale;

        function validatePageLocale(forceLocaleCheck, disableRecommendModal, overridesTo) {
            return recommendLocalePopupPromise(forceLocaleCheck, overridesTo)
                .then(function (proposedLocale) {
                    if (proposedLocale !== getCurrentLocale()) {
                        $rootScope.recommendLocale = proposedLocale
                        if (disableRecommendModal) {
                            // ignore
                        } else {
                            $rootScope.showRecommendLocaleModal = true;
                        }
                    }
                })
                .catch(function (e) {
                    //ignore
                })
        }

        function getUserVisitingInfoPromise(forceFetch) {
            var promise;
            var userGeoObject = $rootScope.getLocalStorage("iplocale");
            var refetch = false
            if (forceFetch) {
                refetch = true
            } else if (!userGeoObject) {
                refetch = true
            } else if (userGeoObject.expiry) {
                if (Date.now() >= userGeoObject.expiry) {
                    refetch = true
                }
            }
            if (!userGeoObject || refetch) {
                promise = $http.post('/country')
                    .then(function (response) {
                        var geoResponse = response.data;
                        var proposedLocale = "" // default ca
                        if (geoResponse.country === 'CA') {
                            proposedLocale = ''
                        } else {
                            proposedLocale = "en-us"
                        }
                        var toSaveGeoObject = {
                            locale: proposedLocale,
                            expiry: Date.now() + (60000 * 60 * 24 * 7),
                            country: geoResponse.country,
                            region: geoResponse.region,
                            city: geoResponse.city,
                        }

                        $rootScope.setLocalStorage("iplocale", JSON.stringify(toSaveGeoObject));
                        return toSaveGeoObject
                    })
                    .catch(function (e) {
                        return $q.reject()
                    })
            } else {
                // console.log(userGeoObject);
                promise = $q.resolve(userGeoObject)
            }
            return promise
        }

        // remove locale
        function getCurrentBasePath() {
            var urlPath = $location.path().split('/');
            urlPath.shift();
            if (isValidLocale(urlPath[0])) {
                urlPath.shift();
            }
            urlPath = urlPath.join('/');
            return '/' + urlPath;
        }

        // 1. determine country from url
        // 2. if popup not closed before, geolocate (async) ip and determine best viewing website
        function recommendLocalePopupPromise(forceLocaleCheck, overridesLocale) {
            var promise;
            
            // Skip for bot/crawler user agents
            if (isBotUserAgent()) {
                return $q.resolve(currentLocale);
            }
            
            if (!_.isUndefined(overridesLocale)) {
                promise = $q.resolve(overridesLocale);
            } else {
                var confirmExpiry = $rootScope.getLocalStorage('userConfirmedLocation');
                if (!forceLocaleCheck && confirmExpiry && Date.now() <= Number(confirmExpiry)) {
                    promise = $q.resolve(currentLocale);
                } else {
                    promise = getUserVisitingInfoPromise(forceLocaleCheck)
                        .then(function (userGeoObject) {
                            return userGeoObject.locale
                        })
                }
            }

            return promise;
        }
        
        // Helper function to detect bots by user agent
        function isBotUserAgent() {
            var userAgent = navigator.userAgent || '';
            userAgent = userAgent.toLowerCase();
            
            // Common bot patterns
            var botPatterns = [
                'bot', 'spider', 'crawler', 'scraper', 'preview', 
                'prerender', 'headless', 'phantom', 'selenium', 'puppeteer', 
                'lighthouse', 'slurp', 'facebookexternalhit', 'whatsapp',
                'googlebot', 'bingbot', 'yahoo', 'baiduspider', 'yandex',
                'duckduckbot', 'facebot', 'twitterbot', 'pinterest',
                'applebot', 'snapchat', 'discordbot'
            ];
            
            // Check for common bot patterns
            for (var i = 0; i < botPatterns.length; i++) {
                if (userAgent.indexOf(botPatterns[i]) !== -1) {
                    return true;
                }
            }
            
            // Check for typical headless browser tells
            if (navigator.webdriver || 
                navigator.hasOwnProperty('webdriver') || 
                window.callPhantom || 
                window._phantom || 
                window.__nightmare || 
                window.navigator.languages === undefined || 
                window.navigator.languages.length === 0) {
                return true;
            }
            
            return false;
        }

        function isValidLocale(givenLocale) {
            return availableLocalesURLs.includes(givenLocale);
        }

        // meant to run ONCE on initial page load only, if need to set again the page refreshes via shouldReloadApp
        function setLocale(givenLocale, shouldReloadApp) {
            if (!isValidLocale(givenLocale)) {
                throw Error('Invalid Locale ' + givenLocale);
            } else {
                if (currentLocale !== givenLocale) {
                    currentLocale = givenLocale;
                    if (shouldReloadApp) {
                        reloadUrl(true);
                    } else {
                        $timeout(function(){
                            $rootScope.$broadcast('localeReady');
                        }, 100)
                    }
                }
            }
        }

        function reloadUrl(shouldHardReload) {
            var newUrl;
            if (currentLocale) {
                var currentPath = $location.url();
                if (currentPath === '/') {
                    currentPath = ''
                }
                newUrl = '/' + currentLocale + currentPath;
            } else {
                // replace first subfolder directory which would be the locale
                newUrl = $location.url().replace(/\/[^\/]+/, '');
            }
            if (shouldHardReload) {
                window.location.href = newUrl; // app reload
            } else {
                // update location (for internal navigation cart -> checkout)
                $location.url(newUrl);
            }
        }

        function getCurrentLocale() {
            return currentLocale;
        }

        // given absolute url returns a path with correct locale context
        function getRelativeLocaleUrl(url) {
            var baseUrl = $location.protocol() + '://' + location.host;
            // absolute url
            var fallbackUrl = 'https://coastalreign.com'

            var returnUrl = url;
            if (!_.isUndefined(currentLocale)) {
                var matchingPath;
                if (url.indexOf(baseUrl) === 0) {
                    matchingPath = url.substring(baseUrl.length);
                } else if (url.indexOf(fallbackUrl) === 0) {
                    matchingPath = url.substring(fallbackUrl.length);
                }
                if (matchingPath) {
                    returnUrl = matchingPath;
                    var pathLocale = ""; // default ca
                    var firstSubdirectory = matchingPath.split("/")[1]
                    if (isValidLocale(firstSubdirectory)) {
                        pathLocale = firstSubdirectory;
                    }
                    if (pathLocale !== currentLocale) {
                        if (matchingPath === '/') {
                            matchingPath = ''
                        }
                        returnUrl = '/' + currentLocale + matchingPath
                    }
                }
            }


            return returnUrl;
        }

        function textFindAndReplace(stringToCheck) {
            var returnString = stringToCheck;
            if (currentLocale === 'en-us') {
                returnString = returnString
                    .replace(new RegExp(/colour/, "g"), 'color')
                    .replace(new RegExp(/Colour/, "g"), 'Color')
                    .replace(new RegExp(/colours/, "g"), 'colors')
                    .replace(new RegExp(/Colours/, "g"), 'Colors')
                    .replace(new RegExp(/\bgrey\b/, "g"), 'gray')
                    .replace(new RegExp(/\bGrey\b/, "g"), 'Gray')
                    .replace(new RegExp(/\blabour\b/, "g"), 'labor')
                    .replace(new RegExp(/\bLabour\b/, "g"), 'Labor')
                    .replace(new RegExp(/\bOdour\b/, "g"), 'Odor')
                    .replace(new RegExp(/\bodour\b/, "g"), 'Odor')
            }
            return returnString;
        }

        return {
            getUserVisitingInfoPromise: getUserVisitingInfoPromise,
            validatePageLocale: validatePageLocale,
            setLocale: setLocale,
            getRelativeLocaleUrl: getRelativeLocaleUrl,
            isValidLocale: isValidLocale,
            getCurrentLocale: getCurrentLocale,
            reloadUrl: reloadUrl,
            textFindAndReplace: textFindAndReplace,
            getCurrentBasePath: getCurrentBasePath
        };
    }

})();
